<div class="rss-feed-container">
  <h3 class="title">Latest News</h3>
  <div class="news">
    <app-news-list></app-news-list>
  </div>
</div>
